import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { routes } from "./constants/routes";

const Appstart = () => {
  const location = useLocation();

  // exclude login and reset password routes
  const publicPaths = [routes.GPADMIN, routes.RESETPASS];
  const isPublic = publicPaths.includes(location.pathname);

  const storedSession = sessionStorage.getItem("guradPlus_session");
  let sessionToken = null;

  if (storedSession) {
    try {
      const parsed = JSON.parse(storedSession);
      sessionToken = parsed?.sessionData?.jwt || null;
    } catch (err) {
      console.error("Invalid session:", err);
    }
  }

  if (!sessionToken && !isPublic) {
    console.log("No token found → redirecting to login");
    return <Navigate to={routes.GPADMIN} replace />;
  }

  console.log("Token found or on public route → rendering");
  return <Outlet />;
};

export default Appstart;
